<template>
  <div class='un_user-alert' :class='alert.type' @click='onClickAlert'>{{ alert.message }}</div>
</template>
<script>
export default {
  props: [
    'alert'
  ],

  methods: {
    onClickAlert () {
      this.$emit('dismiss', this.alert.id)
    }
  }
}
</script>
<style lang='scss'>
.un_user-alert {
  white-space: pre-line;
  display: block;
  width: 100%;
  max-width: 600px;
  border: 1px solid #EEE;
  margin: 0 auto;
  text-align: center;
  padding: .7rem;
  border-radius: 5px;
  background: #FFF;
  line-height: 1.4em;

  @include respond-to("small") {
    max-width: 100%
  }

  &:hover {
    cursor: pointer;
  }

  &.warning {
    color: darken($c_alerts_warning, 10);
    border-color: $c_alerts_warning;
    background: rgba($c_alerts_warning, 0.05);
  }
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/product-designer/UserAlert.vue